module.exports = __webpack_public_path__ + "static/img/icon-deposit-active.6edec43.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icon-deposit-active.png
// module id = BiFo
// module chunks = 3